import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=5d21a034"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d21a034')) {
      api.createRecord('5d21a034', component.options)
    } else {
      api.reload('5d21a034', component.options)
    }
    module.hot.accept("./HeroSlider.vue?vue&type=template&id=5d21a034", function () {
      api.rerender('5d21a034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/nc/js/components/HeroSlider.vue"
export default component.exports